<template>
  <div class="pane" ref="box2" id="box2" style="width:100%;">
    <div class="ly-list list-view">
      <div class="ly-list-top">
        <div class="ly-title">
          <h3 class="title-sub">{{ $t("messages.titUserList") }}</h3>
        </div>
        <div class="ly-filter">
          


          <div class="ly-search-catalog">
            <template v-if="!$isMobile()">
              <idc-input
                v-model="filterKeyword"
                className="funnel"
                :placeholder="$t('messages.plSearch')"
                size="medium"
                @inputEvent="showSearchFilterView = !showSearchFilterView"
              />
              <div class="ly-search-form" v-if="showSearchFilterView">
                <el-form
                  ref="form"
                  :model="searchFilterData"
                  label-position="left"
                  label-width="87px"
                >
                  <el-form-item label="권한명">
                    <idc-input v-model="searchFilterData.roleNm" size="medium" />
                  </el-form-item>
                  <el-form-item label="성명">
                    <idc-input v-model="searchFilterData.userNm" size="medium" />
                  </el-form-item>
                  <el-form-item label="아이디">
                    <idc-input v-model="searchFilterData.userId" size="medium" />
                  </el-form-item>
                  <el-form-item label="이메일">
                    <idc-input v-model="searchFilterData.email" size="medium" />
                  </el-form-item>
                  <el-form-item label="소속사">
                    <idc-input v-model="searchFilterData.companyNm" size="medium" />
                  </el-form-item>
                  <el-form-item label="소속부서">
                    <idc-input v-model="searchFilterData.deptNm" size="medium" />
                  </el-form-item>
                  <div class="ly-btn">
                    <el-button size="mini" @click="onSearch">
                      <i class="icon-MagnifyingGlass" />
                    </el-button>
                  </div>
                </el-form>
              </div>
            </template>
            <template v-else>
              <el-row class="mobile-filter">
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.roleNm"
                    placeholder="권한명을 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.userNm"
                    placeholder="성명을 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.userId"
                    placeholder="아이디를 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.email"
                    placeholder="이메일을 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.companyNm"
                    placeholder="소속사를 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <idc-input
                    size="medium"
                    v-model="searchFilterData.deptNm"
                    placeholder="소속부서를 입력하세요."
                  />
                </el-col>
                <el-col :span="24">
                  <el-button size="large" type="search" @click="onSearch"
                    ><i class="icon-MagnifyingGlass"
                  /></el-button>
                </el-col>
              </el-row>
            </template>
          </div>

          <div class="ly-sort ly-sort-his ly-sort-list">
            <div class="sort-count">
              <p class="table-cell-all">
                {{ $t("messages.all") }}
                <span class="table-cell-count">{{totalCount}}</span
                >{{ $t("messages.unit") }}
              </p>
            </div>
            <div>
              <el-button plain size="small" type="excel"
                >{{ $t("messages.btnExcel")
                }}<i class="icon-DownloadSimple"></i
              ></el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="ly-list-content scrollY-auto">
        <idc-list
          :tableHeader="tableHeader"
          :tableData="tableData"
          :filterText="filterKeyword"
          @clickRow="clickRow"
        >
        </idc-list>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import IdcList from "@/components/common/IdcList.vue";
import IdcNoData from "@/components/common/IdcNoData.vue";
import IdcInput from "@/components/common/IdcInput.vue";

export default {
  mixins: [commonMixin],
  components: {
    IdcSearchCatalog,
    IdcList,
    IdcNoData,
    IdcInput
  },
  data() {
    return {
      showSearchFilterView: false,
      searchFilterData: {
        roleNm    : "",
        userNm    : "",
        userId    : "",
        email     : "",
        companyNm : "",
        deptNm    : "",
      },
      filterKeyword: '',
      tableHeader: [
        {
          type: "index",
          label: "NO",
          width: 10,
        },
        {
          prop: "roleNm",
          label: "권한명",
          width: 50,
        },
        {
          prop: "companyType",
          label: "업체유형",
          width: 30,
        },
        {
          prop: "userNm",
          label: "성명",
          width: 40,
        },
        {
          prop: "userId",
          label: "아이디",
          width: 40,
        },
        {
          prop: "email",
          label: "이메일",
          width: 60,
        },
        {
          prop: "sex",
          label: "성별",
          width: 20,
        },
        {
          prop: "companyNm",
          label: "소속사",
          width: 60,
        },
        {
          prop: "deptNm",
          label: "소속부서",
          width: 60,
        },
      ],
      tableData: [],
    }
  },
  computed: {
    totalCount() {
      return this.tableData.length || 0;
    },
  },
  created() {
    this.$EventBus.$on("selectedRole", (role) => {
      this.getRoleUserList(role.roleId, {});
    });
  },
  methods: {
    clickRow(col, row) {
      this.$emit("selectedRoleUser", row);
    },
    onSearch() {
      this.showSearchFilterView = !this.showSearchFilterView;
      //this.$emit("searchFilter", this.searchFilterData);
    },
    async getRoleUserList(roleId, searchData) {
      const content = Object.assign({}, searchData, { roleId : roleId });
      const req = await this.$BIZ_SERVICE.post(this.$API_URLS.Com.getUserInfoListByRoleId, content);

      this.tableData = req.data.resData || [];
    },
  }
}
</script>
<style lang="scss" scoped>
.ly-search {
  &-catalog {
    position: relative;
    z-index: 3;
  }
  &-form {
    position: absolute;
    padding: 20px 15px;
    margin-top: 5px;
    background: $--color-white;
    border: 1px solid $--color-light-gray {
      radius: 10px;
    }
    ::v-deep {
      .el-form-item {
        &:not(:first-child) {
          padding-top: 15px;
        }
        &__label {
          font-weight: $--font-weight-Medium;
          line-height: 36px;
          letter-spacing: -2.5px;
          padding-right: 5px;
        }
      }
      .el-select:not(:first-child) {
        padding-top: 5px;
      }
      &.ly-type2 {
        .el-form-item {
          &__content {
            margin-left: 0 !important;
            line-height: 1.2;
            .el-select {
              width: 100%;
            }
          }
        }
      }
      &.ly-type3 {
        .el-form-item__content {
          display: flex;
          align-items: baseline;
          gap: 5px;
        }
      }
      .ly-btn {
        padding-top: 15px;
        text-align: right;
        .el-button--mini {
          padding: 0;
          width: 36px;
          height: 36px;
          background: #000;
          color: $--color-white;
          border: 0;
          font-size: $--font-size-large;
        }
      }
    }
  }
}
.mobile-filter {
  ::v-deep {
    .el-col:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
</style>